<ng-container *ngIf="isOpen">

  <!-- Full-screen backdrop — captures click-outside to close the panel -->
  <div class="fixed inset-0 z-40" (click)="close()"></div>

  <!-- Panel — positioned below the bell button (parent div is position:relative) -->
  <div class="absolute right-0 z-50 mt-2 flex w-[380px] flex-col overflow-hidden rounded-xl border border-slate-200 bg-white shadow-2xl" style="top: 100%">

    <!-- Header -->
    <div class="flex flex-shrink-0 items-center justify-between border-b border-slate-200 px-4 py-3">
      <div class="flex items-center gap-2">
        <span class="text-sm font-semibold text-slate-900">Notifications</span>
        <span
          *ngIf="unreadCount > 0"
          class="rounded-full bg-violet-100 px-1.5 py-0.5 text-[11px] font-semibold text-violet-700"
        >{{ unreadCount }}</span>
      </div>
      <div class="flex items-center gap-1">
        <button
          *ngIf="unreadCount > 0"
          (click)="markAllAsRead()"
          [disabled]="marking"
          class="rounded px-2 py-1 text-xs text-slate-500 transition-colors hover:bg-slate-100 hover:text-slate-800 disabled:opacity-50"
        >Mark all read</button>
        <button
          (click)="close()"
          class="rounded p-1 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-700"
        >
          <lucide-icon name="x" [size]="14" [strokeWidth]="2"></lucide-icon>
        </button>
      </div>
    </div>

    <!-- Body -->
    <div class="max-h-[464px] overflow-y-auto">

      <!-- Loading skeleton -->
      <div *ngIf="loading" class="space-y-0.5 p-2">
        <div *ngFor="let _ of [1, 2, 3]" class="flex items-start gap-3 rounded-lg px-3 py-3">
          <div class="h-7 w-7 flex-shrink-0 animate-pulse rounded-full bg-slate-200"></div>
          <div class="flex-1 space-y-2 pt-0.5">
            <div class="h-2.5 w-3/4 animate-pulse rounded bg-slate-200"></div>
            <div class="h-2.5 w-1/2 animate-pulse rounded bg-slate-200"></div>
          </div>
        </div>
      </div>

      <!-- Error state -->
      <div *ngIf="!loading && hasError" class="flex flex-col items-center gap-2 px-4 py-10 text-center">
        <lucide-icon name="triangle-alert" [size]="20" class="text-slate-300" [strokeWidth]="1.5"></lucide-icon>
        <p class="text-xs text-slate-400">Failed to load notifications.</p>
        <button (click)="load()" class="text-xs text-violet-600 hover:text-violet-800">Try again</button>
      </div>

      <!-- Empty state -->
      <div *ngIf="!loading && !hasError && items.length === 0" class="flex flex-col items-center gap-2 py-12 text-center">
        <lucide-icon name="check" [size]="24" class="text-slate-300" [strokeWidth]="1.5"></lucide-icon>
        <p class="text-sm font-medium text-slate-500">All caught up</p>
        <p class="text-xs text-slate-400">No critical events to review.</p>
      </div>

      <!-- Notification items -->
      <div *ngIf="!loading && !hasError && items.length > 0" class="space-y-0.5 p-2">
        <button
          *ngFor="let item of items"
          (click)="openItem(item)"
          class="group relative w-full rounded-lg px-3 py-3 text-left transition-colors"
          [class.border-l-2]="!item.isRead"
          [class.border-violet-500]="!item.isRead"
          [class.bg-white]="!item.isRead"
          [class.hover:bg-violet-50]="!item.isRead"
          [class.bg-slate-50]="item.isRead"
          [class.hover:bg-slate-100]="item.isRead"
        >
          <div class="flex items-start gap-3">

            <!-- Icon -->
            <div
              class="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full"
              [ngClass]="iconBg(item)"
            >
              <lucide-icon [name]="iconName(item)" [size]="13" class="text-white" [strokeWidth]="2.25"></lucide-icon>
            </div>

            <!-- Text -->
            <div class="min-w-0 flex-1">
              <p
                class="text-sm leading-snug"
                [class.font-semibold]="!item.isRead"
                [class.text-slate-900]="!item.isRead"
                [class.font-medium]="item.isRead"
                [class.text-slate-500]="item.isRead"
              >{{ item.title }}</p>
              <p class="mt-0.5 truncate text-xs text-slate-400">{{ item.body }}</p>
              <p class="mt-1 text-[11px] text-slate-400">{{ relativeTime(item.createdAt) }}</p>
            </div>

            <!-- Unread dot -->
            <div *ngIf="!item.isRead" class="mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-violet-500"></div>

          </div>
        </button>
      </div>

    </div>

  </div>

</ng-container>
